import { render, staticRenderFns } from "./AutoTestTotal.vue?vue&type=template&id=6f0629dd&scoped=true&"
import script from "./AutoTestTotal.vue?vue&type=script&lang=js&"
export * from "./AutoTestTotal.vue?vue&type=script&lang=js&"
import style0 from "./AutoTestTotal.vue?vue&type=style&index=0&id=6f0629dd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0629dd",
  null
  
)

export default component.exports